<template>
  <div>
  <div class="order-main">
        <div class="tabs-wrapper">
          <b-tabs lazy>
            <!-- Contract details tab -->
            <b-tab :title="$t('globals.contract_details')">
              <b-row >
               
                <b-col>
                  <b-btn size="sm" class="m-1 float-right" variant="info" v-if="!edit" @click="edit = true">
                    {{ $t("globals.edit") }}
                  </b-btn>
                  <b-btn size="sm" variant="warning" class="float-right m-1" v-if="edit" @click="cancelEdit">
                    {{ $t("globals.cancel") }}
                  </b-btn>
                </b-col>
              </b-row>

              <b-row v-if="has_shared_web_app_id">
                <b-col>
                  <b-card bg-variant="light">
                    <b-row>
                      <b-col>
                        <h5 class="text-info m-1">{{ $t("globals.shared_web_app_id_detected") }}:</h5>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        {{ saved_default_my_environment_customer ? $t("globals.used_as_default") : $t("globals.not_used_as_default") }}
                        <b-form-checkbox v-model="default_my_environment_customer" :disabled="!edit" inline class="ml-2" />
                        <b-btn size="sm" variant="success" class="float-right m-1" v-if="edit"
                          @click="save_default_my_environment">
                          {{ $t("globals.save") }}
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>

              <b-row :style="has_shared_web_app_id ? { marginTop: '2em' } : {}" v-if="!isthereContractDetail">
                <b-col>
                  <b-card bg-variant="light">
                    <b-row>
                      <b-col>
                        {{ $t("globals.contract_type") }}:
                        <b-form-select v-model="new_details.contract_type"
                          :options="contractDetailsSet['contract_types']"></b-form-select>
                      </b-col>
                      <b-col>
                        {{ $t("globals.start_date") }}:
                        <b-form-datepicker id="start_date-datepicker" v-model="new_details.start_date" class="mb-2"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric'
                          }"></b-form-datepicker>
                      </b-col>
                      <b-col>
                        {{ $t("globals.contract_duration") }}: 
                        <b-form-select v-model="new_details.duration" :options="contractDetailsSet['durations']"></b-form-select>
                      </b-col>
                      <b-col>
                        {{ $t("globals.contract_termination_policy") }}:
                        <b-form-select v-model="new_details.termination_policy"
                          :options="contractDetailsSet['termination_policies']"></b-form-select>
                        <b-btn size="sm" variant="success" class="float-right m-1" @click="create_details(new_details)"
                          :disabled="!can_create">
                          {{ $t("globals.save") }}
                        </b-btn>
                      </b-col>
                    </b-row>
                    <span class="small" v-if="data_from_first_order">
                      *Information from first order
                    </span>
                  </b-card>
                </b-col>
              </b-row>

              <b-row style="margin-top: 2em" v-else>
                <b-col>
                  <b-card bg-variant="light">
                    <b-row>
                      <b-col>
                        {{ $t("globals.contract_type") }}:
                        <b-form-select v-model="contract_details.contract_type" :options="contractDetailsSet['contract_types']"
                          :disabled="!edit"></b-form-select>
                      </b-col>
                      <b-col>
                        {{ $t("globals.start_date") }}:
                        <b-form-datepicker id="start_date-datepicker" v-model="contract_details.start_date" class="mb-2"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric'
                          }" :disabled="!edit"></b-form-datepicker>
                      </b-col>
                      <b-col>
                        {{ $t("globals.contract_duration") }}: 
                        <b-form-select v-model="contract_details.duration" :options="contractDetailsSet['durations']"
                          :disabled="!edit"></b-form-select>
                      </b-col>
                      <b-col>
                        {{ $t("globals.contract_termination_policy") }}:
                        <b-form-select v-model="contract_details.termination_policy"
                          :options="contractDetailsSet['termination_policies']" :disabled="!edit"></b-form-select>
                        <b-btn size="sm" variant="success" class="float-right m-1" v-if="edit"
                          @click="save_detail(contract_details)">
                          {{ $t("globals.save") }}
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>

              <b-row style="margin-top: 2em">
                <b-col>
                  <b-card bg-variant="light">
                    <b-row>
                      <b-col>
                        <h5 class="text-info ">{{ $t("globals.price_list") }}:</h5>
                      </b-col>
                    </b-row>
                    <b-row>
                      <ulu-customer-items :price_list="price_list" :editable="edit"
                        :id="contract_details_present ? contract_details.id : 0" :refresh="fetchCustomerContractData" />
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>

              <b-row style="margin-top: 2em">
                <b-col>
                  <b-card bg-variant="light">
                    <b-row>
                      <b-col>
                        <h5 class="text-info m-1">{{ $t("globals.notes") }}:</h5>
                      </b-col>
                      <b-col>
                        <b-btn size="sm" variant="success" class="float-right m-1" v-if="edit" @click="save">
                          {{ $t("globals.save") }}
                        </b-btn>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-textarea v-model="notes" rows="20" :disabled="!edit">
                        </b-form-textarea>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
                <b-col>
                
                  <b-card bg-variant="light">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5 class="text-info m-1">{{ $t("globals.my_environment_exceptions") }}:</h5>
                      </b-col>
                      <b-col cols="12" md="4" v-if="getUserBrandPermissions && getUserBrandPermissions.super_admin && contract_details_present">
                        <b-btn size="sm" variant="success" class="float-right m-1" v-if="edit && contract_details_present"
                          @click="save_environment_exceptions(contract_details)">
                          {{ $t("globals.save") }}
                        </b-btn>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col v-for="exception in contractDetailsSet['my_environment_exceptions']" :key="exception">
                        <b-form-checkbox v-if="getUserBrandPermissions && getUserBrandPermissions.super_admin"
                          :checked="selected_environment_exceptions.includes(exception)"
                          @change="toggleEnvironmentException(exception, $event)"
                          :disabled="!edit">
                          {{ exception }}
                        </b-form-checkbox>
                        <span v-else>
                          {{ exception }}
                        </span>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <!-- First order --> 
            <b-tab :title="$t('globals.first_order')" v-if="first_order">
              <b-row >
                <!-- First order -->
                <b-col>
                  <b-card bg-variant="light">
                    <ulu-order></ulu-order>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <!-- Accepted inquiries tab -->
            <b-tab :title="$t('globals.accepted_inquiries')">
              <ulu-customer-accepted-inquiries :accepted_inquiries="accepted_inquiries" />
            </b-tab>
            
          </b-tabs>
        </div>
      </div>

    
   
    

    
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "ulu-customer-items": () => import("@/components/customers/customer/CustomerContractDetailsPricelist"),
    "ulu-order": () => import("@/components/orders/order/Order"),
    "ulu-customer-accepted-inquiries": () => import("@/components/customers/customer/CustomerAcceptedInquiries")
  },
  props: {
    notes: String,
    refresh: Function,
    
  },
  data() {
    return {
      shared_web_app_id: null,
      default_my_environment_customer: false,
      saved_default_my_environment_customer: false,
      contract_details: {},
      first_order: {},
      accepted_inquiries: {},
      edit: false,
      selected_environment_exceptions: [],

      new_details: {
        contract_type: "",
        start_date: "",
        duration: "",
        termination_policy: ""
      },
      data_from_first_order: false
    };
  },
  methods: {
    ...mapActions(["fetchContracDetailsSets", "fecthCustomerOrdersItems"]),
    ...mapActions("axios_mod", ["simpleMutation", "simpleFetch"]),


    getEnvironmentExceptionsFromDetail(detail) {
      if (!detail) {
        return [];
      }

      if (Array.isArray(detail.my_environment_exceptions)) {
        return detail.my_environment_exceptions;
      }
      if (Array.isArray(detail.environment_exceptions)) {
        return detail.environment_exceptions;
      }
      if (typeof detail.my_environment_exceptions === "string") {
        return detail.my_environment_exceptions ? [detail.my_environment_exceptions] : [];
      }
      if (typeof detail.environment_exceptions === "string") {
        return detail.environment_exceptions ? [detail.environment_exceptions] : [];
      }

      return [];
    },
    toggleEnvironmentException(exception, checked) {
      const current = this.selected_environment_exceptions.slice();
      if (checked) {
        if (!current.includes(exception)) {
          current.push(exception);
        }
      } else {
        const index = current.indexOf(exception);
        if (index !== -1) {
          current.splice(index, 1);
        }
      }

      this.selected_environment_exceptions = current;
      if (this.contract_details) {
        this.$set(this.contract_details, "my_environment_exceptions", current.slice());
        this.$set(this.contract_details, "environment_exceptions", current.slice());
      }
    },
    syncEnvironmentExceptions(detail) {
      const rawValue = this.getEnvironmentExceptionsFromDetail(detail);
      this.selected_environment_exceptions = Array.isArray(rawValue)
        ? rawValue.map(value => String(value).trim())
        : rawValue
          ? [String(rawValue).trim()]
          : [];
      if (this.contract_details) {
        this.$set(this.contract_details, "my_environment_exceptions", this.selected_environment_exceptions.slice());
        this.$set(this.contract_details, "environment_exceptions", this.selected_environment_exceptions.slice());
      }
    },
    cancelEdit() {
      this.edit = false;
      this.refresh();
      this.fetchCustomerContractData();
    },
    mutateAndRefresh(data) {
      return this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelEdit();
      });
    },
    save() {
      let data = {
        query: `
          mutation CustomerUpdateNotes($customer_id: ID!, $new_notes: String!) {
            res: CustomerUpdateNotes (customer_id: $customer_id, new_notes: $new_notes)
          }
        `,
        variables: {
          customer_id: parseInt(this.$route.params.id),
          new_notes: this.notes
        }
      };
      this.mutateAndRefresh(data);
    },
    save_default_my_environment() {
      let data = {
        query: `
          mutation($customerId: ID!, $default: Boolean!) {
            res: CustomerUpdateDefaultMyEnvironment(customer_id: $customerId, default_my_environment_customer: $default)
          }
        `,
        variables: {
          customerId: this.$route.params.id,
          default: !!this.default_my_environment_customer
        }
      };
      this.mutateAndRefresh(data);
    },
    save_environment_exceptions(detail) {
      if (!detail || !detail.id) {
        return;
      }

      const exceptions = Array.isArray(this.selected_environment_exceptions)
        ? this.selected_environment_exceptions
        : [];
      const serializedExceptions = exceptions
        .map(exception => `"${String(exception).replace(/"/g, '\\"')}"`)
        .join(", ");

      let data = {
        query: `
        mutation {
          res:
            MyEnvironmentCustomerExceptionsEdit(
                id:${detail.id},
                my_environment_exceptions: [${serializedExceptions}]
              )
            }
        `
      };
      this.mutateAndRefresh(data);
    },
    save_detail(detail) {
      let data = {
        query: `
        mutation {
          res:
            CustomerContractDetailsEdit(
                id:${detail.id},
                contract_type: "${detail.contract_type}",
                start_date: "${detail.start_date}",
                duration: "${detail.duration}",
                termination_policy: "${detail.termination_policy}"
              )
            }
        `
      };
      this.mutateAndRefresh(data);
    },
    create_details() {
      let data = {
        query: `
        mutation {
          res:
            CustomerContractDetailsCreate(
                customer_id:${parseInt(this.$route.params.id)},
                contract_type: "${this.new_details.contract_type}",
                start_date: "${this.new_details.start_date}",
                duration: "${this.new_details.duration}",
                termination_policy: "${this.new_details.termination_policy}"
              )
            }
        `
      };
      this.mutateAndRefresh(data);
    },
    setDetailsFromFirstOrder() {
      if (Object.keys(this.first_order).length > 0) {
        this.data_from_first_order = true;
        this.new_details.start_date = this.first_order.contract_start_on;
        this.new_details.duration = this.first_order.contract_duration;
        this.new_details.termination_policy = this.first_order.payment_term_name;
        this.new_details.contract_type = this.first_order.order_type;
      }
    },
    fetchCustomerContractData() {
      const data = {
        query: `
          query {
            Customer(id: ${this.$route.params.id}) {
              shared_web_app_id
              default_my_environment_customer
              customer_contract_detail {
                id
                contract_type
                start_date
                duration
                termination_policy
                contract_detail_items {
                  id
                  price_one_time
                  price_per_month
                  name
                  item_type
                  billing_item_id
                }
                my_environment_exceptions
              }
              first_order {
                contract_start_on
                contract_duration
                payment_term_name
                order_type
              }
              inquiry_acceptances {
                id
                terms_version
                accepted_at
                accepted_timezone
                signed_first_name
                signed_last_name
                has_signed_pdf
                inquiry {
                  id
                  inquiry_no
                  inquiry_group {
                    contract_duration
                    payment_term
                    payment_term_name
                    notes
                    total_price_one_time_with_discount
                    total_price_per_month_with_discount
                    items {
                      item_name
                      quantity
                      price_one_time
                      price_per_month
                      discount
                      vat
                      currency
                      is_device
                      kpi_type
                    }
                  }
                }
                customer {
                  company_name
                  company_address
                  company_city
                  company_postal_code
                  company_country
                  company_vat
                  contact_first_name
                  contact_last_name
                  contact_email
                  contact_phone
                  contact_address
                  contact_city
                  contact_postal_code
                  contact_country
                  billing_first_name
                  billing_last_name
                  billing_email
                  billing_phone
                  billing_address
                  billing_city
                  billing_postal_code
                  billing_country
                }
              }
            }
          }
        `
      };

      this.simpleFetch({ data, this_ref: this }).then(res => {
        const customer = res && res.Customer ? res.Customer : null;
        if (!customer) {
          return;
        }
        this.$set(this, "saved_default_my_environment_customer", !!customer.default_my_environment_customer);
        this.$set(this, "default_my_environment_customer", this.saved_default_my_environment_customer);
        this.$set(this, "shared_web_app_id", customer.shared_web_app_id || null);
        this.$set(this, "contract_details", customer.customer_contract_detail || null);
        this.$set(this, "first_order", customer.first_order || {});
        this.$set(this, "accepted_inquiries", customer.inquiry_acceptances || []);

        this.syncEnvironmentExceptions(this.contract_details);
        if (!this.isthereContractDetail) {
          this.setDetailsFromFirstOrder();
        }
      });
    }
  },
  created() {
    this.fetchCustomerContractData();
    
    const set = this.getContractDetailsSet;
    if (!set || !set.contract_types || set.contract_types.length === 0) {
      this.fetchContracDetailsSets();
    }
    
    this.fecthCustomerOrdersItems(this.$route.params.id);
  },
  computed: {
    ...mapGetters(["getContractDetailsSet", "getCustomerOrdersItems", "getUserBrandPermissions"]),
    contractDetailsSet() {
      return this.getContractDetailsSet;
    },
    has_shared_web_app_id() {
      return !!this.shared_web_app_id;
    },
    isthereContractDetail() {
      return this.contract_details != null;
    },
    can_create() {
      return this.new_details.contract_type != "" && this.new_details.start_date != "" && this.new_details.duration != "" && this.new_details.termination_policy != "";
    },
    contract_details_present() {
      return this.contract_details != null && Object.keys(this.contract_details).length > 0;
    },
    
    price_list() {
      if (!this.getCustomerOrdersItems) return [];

      const contract_detail_items = this.contract_details && this.contract_details.contract_detail_items ? this.contract_details.contract_detail_items : [];
      const customer_orders_items = this.getCustomerOrdersItems;
      
      const itemsToAdd = customer_orders_items.filter(new_item => 
        !contract_detail_items.some(
          ({ billing_item_id, name, item_type }) => {
            const sameBillingItem = new_item.billing_item && new_item.billing_item.id && billing_item_id === new_item.billing_item.id;
            const sameNameAndType = name === new_item.item_name && item_type === new_item.item_type;
            return sameBillingItem || sameNameAndType;
          }
        )
      ).map(new_item => {
        const discount = Number(new_item.discount) || 0;
        // whole cents, never below 0, so the row passes the price validation
        const netPrice = price => (price > 0 ? Math.max(0, Math.round(Number(price) - discount)) : Number(price) || 0);
        return {
          id: null,
          price_one_time: netPrice(new_item.price_one_time),
          price_per_month: netPrice(new_item.price_per_month),
          name: new_item.item_name,
          item_type: new_item.item_type,
          billing_item_id: new_item.billing_item && new_item.billing_item.id ? new_item.billing_item.id : null,
          discount: discount,
          order: new_item.order || null
        };
      });

      return [...contract_detail_items, ...itemsToAdd];
    }

  }
};
</script>
